import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrCheckboxGroupComponent } from "../../../../shared/emr-checkbox-group/emr-checkbox-group.component";
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { FormOption } from 'src/app/shared/models/form-option.model';
import { IntegumentaryFormGroup } from 'src/app/calvin-emr-shared/models/assessments/integumentary.model';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { WnlGroupDirective } from '../wnl/wnl-group.directive';
import { WnlControlDirective } from '../wnl/wnl-control.directive';

@Component({
  selector: 'app-integumentary-form',
  templateUrl: './integumentary-form.component.html',
  styleUrls: ['./integumentary-form.component.scss', '../assessments-tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AssessmentRowComponent,
    EmrCheckboxGroupComponent,
    EmrInputComponent,
    WnlGroupDirective,
    WnlControlDirective,
  ],
})
export class IntegumentaryFormComponent implements OnInit {

  patient = input.required<Patient>();
  formGroup = input.required<IntegumentaryFormGroup>();

  skinAppearanceOptions = [
    new FormOption('Diaphoresis'),
    new FormOption('Pallor'),
    new FormOption('Poor turgor'),
    new FormOption('Cool'),
    new FormOption('Modeling'),
    new FormOption('Jaundice'),
    new FormOption('Rash'),
    new FormOption('Lesions'),
    new FormOption('Incision'),
  ];

  skinAppearanceOptionsPediatric = [
    new FormOption('Diaphoresis'),
    new FormOption('Pallor'),
    new FormOption('Poor turgor'),
    new FormOption('Cool'),
    new FormOption('Modeling'),
    new FormOption('Jaundice'),
    new FormOption('Rash'),
    new FormOption('Lesions'),
    new FormOption('Incision'),
    new FormOption('Lanugo'),
    new FormOption('Milia'),
    new FormOption('Nervus Simplex'),
  ];

  stagingOptions = [
    new FormOption('Stage One'),
    new FormOption('Stage Two'),
    new FormOption('Stage Three'),
    new FormOption('Stage Four'),
    new FormOption('Unstageable'),
  ];

  careOptions = [
    new FormOption('ABD'),
    new FormOption('Gauze'),
    new FormOption('Wet to dry dressing change'),
    new FormOption('Pharmaceutical agent (See MAR)'),
    new FormOption('Steri strips'),
    new FormOption('Staples'),
    new FormOption('Well Approximated'),
    new FormOption('Dehiscence'),
  ];

  reset() {
    this.formGroup().enable({ emitEvent: false });
  }

  ngOnInit(): void {
  }

  // get skinAppearanceFormControl(): UntypedFormControl {
  //   return this.formGroup().controls.skinAppearance as UntypedFormControl;
  // }

  // get skinAppearanceCommentFormControl(): UntypedFormControl {
  //   return this.formGroup().controls.skinAppearanceComment as UntypedFormControl;
  // }

  get needCommentBox(): boolean {
    const selectedValues = this.formGroup().controls.skinAppearance.value;
    if (!Array.isArray(selectedValues)) {
      return false;
    }
    return selectedValues.some(value => ['Rash', 'Lesions', 'Incision', 'Lanugo', 'Milia', 'Nervus Simplex'].includes(value));
  }

  // get locationFormControl(): UntypedFormControl {
  //   return this.formGroup().get('location') as UntypedFormControl;
  // }

  // get stagingFormControl(): UntypedFormControl {
  //   return this.formGroup().get('staging') as UntypedFormControl;
  // }

  // get careFormControl(): UntypedFormControl {
  //   return this.formGroup().get('care') as UntypedFormControl;
  // }
}
